"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
/**
 * A component for picking dates and times.
 */
const DateTimePickerComponent = ({ date, timepicker, onChange }) => {
    return react_1.default.createElement("div", null,
        react_1.default.createElement(react_datepicker_1.default, { selected: date ? date.toDate() : undefined, showTimeSelect: timepicker, inline: true, showMonthDropdown: true, showYearDropdown: true, onChange: (date) => {
                onChange(date ? (0, moment_1.default)(date) : undefined);
            } }),
        date &&
            react_1.default.createElement("a", { className: "link-plain", onClick: () => onChange(undefined) }, T `Clear`));
};
exports.default = DateTimePickerComponent;
